// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__2UY55","content":"app_content__23gcS","detail":"app_detail__1zJGl","list":"app_list__EmyaF"};